import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../util/util'

//category thunks
export const readOnDemandCategories = createAsyncThunk(
	'readOnDemandCategories',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'readOnDemandCategories',...payload}
	)
)

export const sortOnDemandCategories = createAsyncThunk(
	'sortOnDemandCategories',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'sortOnDemandCategories',...payload}
	)
)

export const createOnDemandCategory = createAsyncThunk(
	'createOnDemandCategory',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'createOnDemandCategory',...payload}
	)
)

export const editOnDemandCategory = createAsyncThunk(
	'editOnDemandCategory',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'editOnDemandCategory',...payload}
	)
)

export const removeOnDemandCategory = createAsyncThunk(
	'removeOnDemandCategory',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'removeOnDemandCategory',...payload}
	)
)

//video thunks
export const readOnDemandVideos = createAsyncThunk(
	'readOnDemandVideos',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'readOnDemandVideos',...payload}
	)
)

export const createOnDemandVideo = createAsyncThunk(
	'createOnDemandVideo',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'createOnDemandVideo',...payload}
	)
)

export const editOnDemandVideo = createAsyncThunk(
	'editOnDemandVideo',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'editOnDemandVideo',...payload}
	)
)

export const removeOnDemandVideo = createAsyncThunk(
	'removeOnDemandVideo',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'removeOnDemandVideo',...payload}
	)
)

export const removeOnDemandVideos = createAsyncThunk(
	'removeOnDemandVideos',
	async payload => await envAwarePost(
		'api/on-demand/',
		{action:'removeOnDemandVideos',...payload}
	)
)

const categoriesAdapter = createEntityAdapter()
const videosAdapter = createEntityAdapter()

const slice = createSlice({
	name: 'onDemand',
	initialState : {
		categories:categoriesAdapter.getInitialState({
			status:'init',
			editor:{
				show:false,
				id:null
			}
		}),
		videos:videosAdapter.getInitialState({
			status:'init',
			category_id:null,
			editor:{
				show:false,
				id:null
			}
		}),
	},
	reducers : {
		updateCategoryEditor: (state,action)=>{
			state.categories.editor = {
				...state.categories.editor,
				...action.payload
			}
		},
		updateVideoEditor: (state,action)=>{
			state.videos.editor = {
				...state.videos.editor,
				...action.payload
			}
		}
	},
	extraReducers : {
		//category reducers
		[readOnDemandCategories.pending] : (state)=>{
			state.categories.status = 'pending'
		},
		[readOnDemandCategories.fulfilled] : (state,action)=>{
			state.categories.status = 'idle'
			categoriesAdapter.setAll(
				state.categories,
				action.payload.data.on_demand_categories
			)
		},
		[createOnDemandCategory.fulfilled] : (state,action)=>{
			categoriesAdapter.upsertOne(
				state.categories,
				action.payload.data.on_demand_category
			)
		},
		[editOnDemandCategory.pending] : (state,action)=>{
			const {id,update:changes} = action.meta.arg
			categoriesAdapter.updateOne(state.categories,{id,changes})
		},
		[removeOnDemandCategory.pending] : (state,action)=>{
			const {id} = action.meta.arg
			categoriesAdapter.removeOne(state.categories,id)
		},

		//video reducers
		[readOnDemandVideos.pending] : (state,action)=>{
			state.videos.status = 'pending'
			state.videos.category_id = action.meta.arg.category_id
			videosAdapter.setAll(state.videos,[])
		},
		[readOnDemandVideos.fulfilled] : (state,action)=>{
			state.videos.status = 'idle'
			videosAdapter.setAll(
				state.videos,
				action.payload.data.on_demand_videos
			)
		},
		[createOnDemandVideo.fulfilled] : (state,action)=>{
			videosAdapter.upsertOne(
				state.videos,
				action.payload.data.on_demand_video
			)
		},
		[editOnDemandVideo.pending] : (state,action)=>{
			const {id,update:changes} = action.meta.arg
			videosAdapter.updateOne(state.videos,{id,changes})
		},
		[editOnDemandVideo.fulfilled] : (state,action)=>{
			const {on_demand_video} = action.payload.data
			videosAdapter.upsertOne(state.videos,on_demand_video)
		},
		[removeOnDemandVideo.pending] : (state,action)=>{
			const {id} = action.meta.arg
			videosAdapter.removeOne(state.videos,id)
		},
		[removeOnDemandVideos.pending] : (state,action)=>{
			const {ids} = action.meta.arg
			videosAdapter.removeMany(state.videos,ids)
		},
		[sortOnDemandCategories.pending] : (state,action)=>{
			const {categories} = action.meta.arg
			categoriesAdapter.setAll(state.categories,categories)
		}
	}
})

export const {
	updateCategoryEditor,
	updateVideoEditor
} = slice.actions

// Export the customized selectors for this categoriesAdapter using `getSelectors`
export const {
	selectAll: selectAllCategories,
	selectById: selectCategoryById,
	selectIds: selectCategoryIds
} = categoriesAdapter.getSelectors( state => state.onDemand.categories )

export const {
	selectAll: selectAllVideos,
	selectById: selectVideoById,
	selectIds: selectVideoIds
} = videosAdapter.getSelectors( state => state.onDemand.videos )

export default slice.reducer











